import { TeamRole } from '../../pm/types';
import { TEAM_ROLE_LABELS } from '../../pm/constants';

interface Props {
  role: TeamRole;
}

const RoleBadge: React.FC<Props> = ({ role }) => (
  <span className={`pm-role-badge pm-role-${role}`}>{TEAM_ROLE_LABELS[role]}</span>
);

export default RoleBadge;
